// src/i18n/index.ts
import { createI18n } from 'vue-i18n'

export const SUPPORTED_LOCALES = ['en', 'tr', 'es', 'ru', 'pl', 'de', 'ro'] as const
export type Locale = (typeof SUPPORTED_LOCALES)[number]

function detectStartLocale(): Locale {
  const saved = (localStorage.getItem('locale') || '').toLowerCase() as Locale
  if (SUPPORTED_LOCALES.includes(saved)) return saved
  const nav = (navigator.language || 'en').toLowerCase()
  if (nav.startsWith('tr')) return 'tr'
  if (nav.startsWith('es')) return 'es'
  if (nav.startsWith('pl')) return 'pl'
  if (nav.startsWith('ru')) return 'ru'
  if (nav.startsWith('de')) return 'de'
  if (nav.startsWith('ro')) return 'ro'
  return 'en'
}

export const i18n = createI18n({
  legacy: false, // v11: prefer Composition API
  locale: detectStartLocale(),
  fallbackLocale: 'en',
  messages: {}, // we’ll lazy-load
  numberFormats: {
    en: { currency: { style: 'currency', currency: 'USD' } },
    tr: { currency: { style: 'currency', currency: 'USD' } },
    es: { currency: { style: 'currency', currency: 'USD' } },
    ru: { currency: { style: 'currency', currency: 'USD' } },
    pl: { currency: { style: 'currency', currency: 'USD' } },
    de: { currency: { style: 'currency', currency: 'USD' } },
    ro: { currency: { style: 'currency', currency: 'USD' } },
  },
  datetimeFormats: {
    en: { short: { dateStyle: 'medium', timeStyle: 'short' } },
    tr: { short: { dateStyle: 'medium', timeStyle: 'short' } },
    es: { short: { dateStyle: 'medium', timeStyle: 'short' } },
    ru: { short: { dateStyle: 'medium', timeStyle: 'short' } },
    pl: { short: { dateStyle: 'medium', timeStyle: 'short' } },
    de: { short: { dateStyle: 'medium', timeStyle: 'short' } },
    ro: { short: { dateStyle: 'medium', timeStyle: 'short' } },
  },
})

export async function loadLocale(locale: Locale) {
  if (!i18n.global.availableLocales.includes(locale)) {
    const msgs = await import(`./locales/${locale}.json`)
    i18n.global.setLocaleMessage(locale, msgs.default)
  }
}

export async function setLocale(locale: Locale) {
  await loadLocale(locale)
  i18n.global.locale.value = locale
  document.documentElement.lang = locale
  localStorage.setItem('locale', locale)
}
